import { useTranslations } from 'next-intl';
import { levelMap } from '../const';

export function useVipLevelLabel() {
  const t = useTranslations('vip');

  const getLevelLabel = (level: number): string => {
    const info = levelMap[level];
    if (!info) return ''; // 等级不存在返回空字符串
    return t(info.name) + level;
  };

  return { getLevelLabel };
}
